module.exports = __webpack_public_path__ + "static/item_bg.69a405a5.png";